
export const redirect = (url) =>{

    if(url !== "") window.location.href = url ;
 }